import React, { ReactElement, useRef, useState } from 'react'

import Modal, { ModalHandles } from 'components/Modal'
import { TutorielRaccourci } from 'components/TutorielRaccourci'
import Button, { ButtonStyle } from 'components/ui/Button/Button'
import IconComponent, { IconName } from 'components/ui/IconComponent'

interface OnboardingMobileModalProps {
  onClose: () => void
}

function Accueil(): ReactElement {
  return (
    <>
      <h3 className='flex text-base-bold'>
        <IconComponent
          name={IconName.ChatFill}
          focusable={false}
          aria-hidden={true}
          className='shrink-0 w-5 h-5 fill-primary mr-3'
        />
        Un accès dedié à vos conversations
      </h3>
      <p className='mt-4'>
        Retrouvez l&apos;ensemble de vos conversations avec les bénéficiaires de
        votre portefeuile.
      </p>
      <p className='mt-4'>
        À ce jour, seul l&apos;accès à la messagerie est disponible sur
        l&apos;espace mobile.
      </p>
    </>
  )
}

export default function OnboardingMobileModal({
  onClose,
}: OnboardingMobileModalProps) {
  const modalRef = useRef<ModalHandles>(null)

  const [etape, setEtape] = useState<number>(1)

  return (
    <Modal
      ref={modalRef}
      title="Bienvenue sur l'espace mobile du conseiller"
      onClose={onClose}
    >
      {etape === 1 && <Accueil />}
      {etape === 2 && <TutorielRaccourci />}
      <div className='mt-8'>
        <Button
          onClick={(e) => modalRef.current!.closeModal(e)}
          className='w-full'
        >
          Terminer
        </Button>
        {etape === 1 && (
          <Button
            onClick={() => setEtape(2)}
            style={ButtonStyle.SECONDARY}
            className='mt-2 w-full'
          >
            Créer un raccourci
          </Button>
        )}
      </div>
    </Modal>
  )
}
